import { IframeProvider as types } from "@/core/providers/iframeProvider";

export class MarkdownProvider implements types {
  getIframeUrl = () => {
    return new URL(
      `//test01-awp.hfe.test.meituan.com/in/citadel-embed-assets/html/index.html`,
      window.location.href
    );
  };
}
